import {useState} from "react";
import {useIntl} from "react-intl";
import {ChevronUpIcon, ChevronDownIcon} from "@heroicons/react/24/solid";
import {Color} from "../../types";
import {ColorSquare} from "../color-square/component";

type ExpandableValueProps = {
  value: any;
  isColor?: boolean;
  colors?: Color[];
}

export const ExpandableValue = ({
  value,
  isColor = false,
  colors,
}: ExpandableValueProps) => {

  // hooks
  const intl = useIntl();

  // state
  const [isExpanded, setIsExpanded] = useState(false);

  // utilities
  const render = (v: any) => {
    if (v === null || v === undefined || v === "")
      return null;
    return isColor
      ? <ColorSquare color={v} colors={colors}/>
      : <div className="font-medium">{v}</div>;
  }

  if (Array.isArray(value)) {
    switch (value.length) {
      case 0: return null;
      case 1: return render(value[0]);
      default:
        return (
          <div className="flex flex-col gap-2">
            <div className="flex flex-row justify-between gap-2 mr-0.5">
              <span className="font-medium whitespace-nowrap">
                {value.length} {intl.formatMessage({id: "elements",defaultMessage: "elementi"})}
              </span>
              <div className="flex flex-row items-center gap-1 text-xs text-gray-500 cursor-pointer">
                <span
                  className="underline"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded
                    ? intl.formatMessage({id: "collapse", defaultMessage: "Chiudi"})
                    : intl.formatMessage({id: "expand", defaultMessage: "Espandi"})
                  }
                </span>
                {!isExpanded
                  ? <ChevronDownIcon className="w-3 inline-block" onClick={() => setIsExpanded(!isExpanded)}/>
                  : <ChevronUpIcon className="w-3 inline-block" onClick={() => setIsExpanded(!isExpanded)}/>
                }
              </div>
            </div>
            {isExpanded && (
              <ol className="list-decimal ml-4">
                {value.map((item, index) => (
                  <li key={index} className="text-wrap break-all my-0.5">
                    {render(Array.isArray(item) ? item.join(', ') : item)}
                  </li>
                ))}
              </ol>
            )}
          </div>
        );
    }
  } else {
    return render(value);
  }
}